<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toAddOrEditClick()">新建身份</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="idd"
        label="编号"/>
      <el-table-column
        prop="name"
        label="管理员身份"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toAddOrEditClick(scope.row.uuid,scope.row.name)">
            编 辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            class="mini-el-button"
            plain
            @click="event().onDelClick(scope.row.uuid)">
            删 除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>
  </el-main>
</template>

<script>
import { getGroupList, delGroup } from '../../api/system'
import { setId } from '../../jslib/set-id'
import commoonFunction from '../../mixins/common'

export default {
  mixins: [commoonFunction],
  data() {
    return {
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      total: 0,
      tableData: [
      ],
    };
  },

  components: {
  },
  created() {
    this.network().getGroupList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getGroupList()
    },
    event() {
      return {
        toAddOrEditClick: (uuid, name) => {
          this.$router.push({ path: 'add-class', query: { uuid, name } })
        },
        onDelClick: (uuid) => {
          this.isDel('确定删除身份, 是否继续?', 'delGroup', uuid)
        },
      }
    },
    network() {
      return {
        getGroupList: async () => {
          const { status, data } = await getGroupList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.total = data.total
        },
        delGroup: async (uuid) => {
          const { status } = await delGroup(uuid)
          if (status !== 200) return
          this.network().getGroupList()
          this.$notify({
            title: '删除成功',
            message: '删除身份成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/system/admin-class.vue